<template>
  <div class="container-panel">
    <HeroFilter @routeHandler="getDataHandler" @searchHandler="getSearchData" />
    <keep-alive>
    <DataGridTable
      :dataResult="itemResult"
      :dataDetails="itemFormData"
      :searchData="searchValue"
    />
    </keep-alive>
    <CompanyPlansBenefitsModal
      :isModal="isCurrentActive"
      @updateModal="isCurrentActive = closeModal"
      @getDataResult="passData"
    />
  </div>
</template><script>
import HeroFilter from "@/components/common/HeroFilter.vue";
import DataGridTable from "@/components/partials/reports/plans-benefits/DataGridTable.vue";
import CompanyPlansBenefitsModal from "@/components/partials/modals/CompanyPlansBenefitsModal.vue";
import { ref, onMounted, watch } from "vue";

export default {
  components: {
    HeroFilter,
    CompanyPlansBenefitsModal,
    DataGridTable,
  },
  setup() {
    const isCurrentActive = ref(false);
    const searchValue = ref("");
    const itemResult = ref([]);
    const itemFormData = ref([]);

    const getDataHandler = (result) => {
      isCurrentActive.value = result;
    };

    const getSearchData = (search) => {
      searchValue.value = search;
    };

    const passData = (data, form) => {
      itemResult.value = data;
      itemFormData.value = form;
    };

    onMounted(() => {
      const savedItemResult = localStorage.getItem("itemResult");
      const savedItemFormData = localStorage.getItem("itemFormData");
      const savedSearchValue = localStorage.getItem("searchValue");

      if (savedItemResult) itemResult.value = JSON.parse(savedItemResult);
      if (savedItemFormData) itemFormData.value = JSON.parse(savedItemFormData);
      if (savedSearchValue) searchValue.value = JSON.parse(savedSearchValue);
    });

    watch(itemResult, (val) => {
      localStorage.setItem("itemResult", JSON.stringify(val));
    }, { deep: true });

    watch(itemFormData, (val) => {
      localStorage.setItem("itemFormData", JSON.stringify(val));
    }, { deep: true });

    watch(searchValue, (val) => {
      localStorage.setItem("searchValue", JSON.stringify(val));
    });

    return {
      getDataHandler,
      getSearchData,
      passData,
      isCurrentActive,
      itemResult,
      itemFormData,
      searchValue,
    };
  },
};
</script>